export default __webpack_public_path__ + "static/media/quoteIcon.b14bef62.svg";